export default {
  add: 'add',
  edit: 'edit',
  cancel: 'cancel',
  save: 'save',
  view: 'view',
  delete: 'delete',
  choose: 'choose'
};


// WEBPACK FOOTER //
// ./src/lib/locales/en-US.js